import { render, staticRenderFns } from "./profile.component.vue?vue&type=template&id=4ee44a2a&"
import script from "./profile.component.vue?vue&type=script&lang=ts&"
export * from "./profile.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "profile.component.vue"
export default component.exports